import { createFileRoute, redirect } from '@tanstack/react-router';

/** The Order Lines table now lives inside the overview page's left-rail
 *  navigation. This standalone route is kept only so existing `/lines`
 *  bookmarks resolve — it redirects to the overview with the Order Lines
 *  rail node preselected. */
export const Route = createFileRoute(
  '/(client)/orders-hub/(pages)/(detail)/$id/lines',
)({
  beforeLoad: ({ params }) => {
    throw redirect({
      to: '/orders-hub/$id/overview',
      params: { id: params.id },
      search: { section: 'lines' },
    });
  },
  component: () => null,
});
